import React from "react";
import { Outlet } from "react-router";
import bback from "assets/images/bback.png";

function EarnContainer() {
  return (
    <div className="relative">
      <div className="relative" style={{ zIndex: "-10" }}>
        <img
          src={bback}
          alt="bback"
          className="fixed -bottom-10 w-[480px] px-0"
        />
      </div>
      <div className="pb-10">
        <Outlet />
      </div>
    </div>
  );
}

export default EarnContainer;
